import ninja from "../assets/images/ninja.jpeg";
import telus from "../assets/images/telus.jpg";
import staples from "../assets/images/staples-2.jpg";
import kfh from "../assets/images/kfh-1.jpg";
import digbiHealth from "../assets/images/digbi-health-1.png";
import jonnyOnIt from "../assets/images/jonny-on-it-2.jpg";

export const projectsList = [
  {
    name: "Ninja",
    link: "https://ananinja.com/sa/en",
    image: ninja,
    backgroundColor: "#320E4E",
    description: "An online grocery store based in MENA region.",
  },
  {
    name: "Telus",
    link: "https://www.telus.com/",
    image: telus,
    backgroundColor: "#320E4E",
    description:
      "A multinational telecom company providing services and products.",
  },
  {
    name: "Staples",
    link: "https://www.staples.ca/",
    image: staples,
    backgroundColor: "#FF0000",
    description: "An online e-commerce store based in Amercia and Canada.",
  },
  {
    name: "KFH",
    link: "https://www.telus.com/",
    image: kfh,
    backgroundColor: "#FFFFFF",
    description: `It is the pioneer Islamic bank established in the State of
      Kuwait and today it is one of the foremost Islamic financial
      institutions in the world.`,
  },
  {
    name: "Digbi Health",
    link: "https://digbihealth.com/",
    image: digbiHealth,
    backgroundColor: "#0000FF",
    description: `A digital therapeutics solution powered with AI for Polychronic
      Illnesses.`,
  },
  {
    name: "Jonny On It",
    link: "https://apps.apple.com/us/app/jonny-on-it/id1330021042",
    image: jonnyOnIt,
    backgroundColor: "#0000FF",
    description: `This application connects home owners and realtors to service
      providers in real time with an easy to use mobile application.`,
  },
];
